<div class="my-2">
  <app-responsive-tab navigate="tab" [tabs]="[
    {name: 'stats', title: 'آمار کلی'}, 
    {name: 'seeker', title: 'کارجو'},
    {name: 'sms-send', title: 'ارسال پیامک'},
    {name: 'sms-action', title: 'بازخورد پیامک'}
    ]" (active)="tab=$event.name;">
  </app-responsive-tab>

</div>

<ng-container *ngIf="tab=='stats'">
  <div class="container my-2 d-flex align-items-center justify-content-between">
    <div>
      <h6 class="m-0">{{statsTime | pdate}}</h6>
    </div>
    <button class="btn btn-secondary btn-sm fs-sm" (click)="loadDashboardStats()">دریافت</button>
  </div>

  <div class="container table-responsive">
    <table class="w-100 table table-striped table-sm">
      <thead>
        <tr>
          <td>نوع</td>
          <td>عملیات</td>
          <td>1 ساعت</td>
          <td>1 روز</td>
          <td>میانگین 3 هفته</td>
          <td>تغییرات</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of stats">
          <td>{{row.type}}</td>
          <td>{{row.action}}</td>
          <td [class.red-bg]='row.data.OneHour_Alarm' [class.f-white]='row.data.OneHour_Alarm'>
            {{row.data.OneHour|number}}</td>
          <td [class.red-bg]='row.data.OneDay_Alarm' [class.f-white]='row.data.OneDay_Alarm'>
            {{row.data.OneDay|number}}
          </td>
          <td>{{row.data.average|number:'1.0-0'}}</td>
          <td dir="ltr" [class.orange-bg]='row.data.diff_Alarm' [class.f-white]='row.data.diff_Alarm'>
            <ng-container *ngIf="row.data.diff">
              {{ row.data.diff | number:'1.0-0'}} %
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</ng-container>
<div class="text-center" *ngIf="tab!='stats'">
  <app-date-range sranges="today,yesterday,last7days,last30days,last90days,last180days,last365days"
    [default-range]="'last30days'" [(start)]="reportFrom" [(end)]="reportTo"></app-date-range>

</div>

<ng-container *ngIf="tab=='seeker'">
  <div class="container table-responsive">
    <div class="d-flex pb-2 mb-2">
      <div class="mx-2">
        <select [(ngModel)]="actionReport.interval">
          <option value="Day">روزانه</option>
          <option value="Week">هفتگی</option>
          <option value="Month">ماهانه</option>
          <option value="Year">سالانه</option>
        </select>
      </div>

      <div>
        <button class="btn btn-secondary btn-sm fs-sm" (click)="loadSeekerStats()">دریافت</button>
      </div>
    </div>

    <table class="w-100 table table-striped table-sm table-bordered">
      <thead>
        <tr>
          <td>تاریخ</td>
          <td>کارجوی جدید</td>
          <td>اقدام به پیشتاز</td>
          <td>پیشتاز</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of seekerStats">
          <td>
            {{row.from | pdate:'[yy]/[mm]/[dd]'}} - {{row.to | pdate:'[yy]/[mm]/[dd]'}}
          </td>
          <td>
            <ng-container *ngTemplateOutlet="seekerCell;context:{data:row.actions['new-seeker'], showMore: false}">
            </ng-container>
          </td>
          <td>
            <ng-container *ngTemplateOutlet="seekerCell;context:{data:row.actions['vanguard-paying'], showMore: true}">
            </ng-container>
          </td>
          <td>
            <ng-container *ngTemplateOutlet="seekerCell;context:{data:row.actions['vanguard-paid'], showMore: true}">
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #seekerCell let-data="data" let-showMore="showMore">
    <div class="d-flex justify-content-between align-items-center">
      <div class="pointer" *ngIf="data" (click)="data._showUtm=!data._showUtm">
        {{data?.users|number}} کاربر
        <i class="fa fa-angle-down mr-1"></i>
      </div>
      <div *ngIf="showMore && data?.value" class="">
        {{data?.count|number}} بار
        <br />
        {{data?.value|number}} تومان
      </div>

    </div>

    <div *ngIf="data?._showUtm" class="fs-sm text-left " dir="ltr">
      <div *ngFor="let utm of data?.utm" class="d-flex border-top justify-content-between">
        <div>
          <div *ngIf="utm.campaign">campaign: {{utm.campaign}}</div>
          <div *ngIf="utm.source">source: {{utm.source}}</div>
          <div *ngIf="utm.medium">medium: {{utm.medium}}</div>
        </div>
        <div>{{utm.count|number}}</div>
      </div>
    </div>

  </ng-template>
</ng-container>
<ng-container *ngIf="tab=='sms-send'">
  <div class="container table-responsive">
    <div class="d-flex pb-2 mb-2">
      <div class="mx-2">
        <select [(ngModel)]="smsSendReport.interval">
          <option value="Day">روزانه</option>
          <option value="Week">هفتگی</option>
          <option value="Month">ماهانه</option>
          <option value="Year">سالانه</option>
        </select>
      </div>
      <div>
        <button class="btn btn-secondary btn-sm fs-sm" (click)="loadSmsSendStats()">دریافت</button>
      </div>
    </div>

    <table class="w-100 table table-striped table-sm table-bordered">
      <thead>
        <tr>
          <td>تاریخ</td>
          <td>تعداد</td>
          <td>ارتباط با کارجو</td>
          <td>ارتباط با کارفرما</td>
          <td>آگهی ویژه</td>
          <td>پیامک ورود</td>
          <td>آلرت کارجوی پیشتاز</td>
          <td>تایید سابسکرایب</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of smsSendStats">
          <td>
            {{row.from | pdate:'[yy]/[mm]/[dd]'}} - {{row.to | pdate:'[yy]/[mm]/[dd]'}}
          </td>
          <td>
            <div class="d-flex align-items-center justify-content-between">
              {{row.count | number}}
              <span class="fs-sm" *ngIf="row.parts" title="تعداد پارت پیامک">
                {{row.parts | number}} پارت
              </span>
            </div>
          </td>
          <td>
            <ng-container *ngTemplateOutlet="smsSendCell;context:{data:row.types?.SeekerTouch}"></ng-container>
          </td>
          <td>
            <ng-container *ngTemplateOutlet="smsSendCell;context:{data:row.types?.EmployerTouch}"></ng-container>
          </td>
          <td>
            <ng-container *ngTemplateOutlet="smsSendCell;context:{data:row.types?.PaidJob}"></ng-container>
          </td>
          <td>
            <ng-container *ngTemplateOutlet="smsSendCell;context:{data:row.types?.Authentication}"></ng-container>
          </td>
          <td>
            <ng-container *ngTemplateOutlet="smsSendCell;context:{data:row.types?.PaidMatching}"></ng-container>
          </td>
          <td>
            <ng-container *ngTemplateOutlet="smsSendCell;context:{data:row.types?.VerifySubscribe}"></ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #smsSendCell let-data="data">
    <div class="pointer" *ngIf="data" (click)="data._more=!data._more">
      {{data?.count|number}} ({{data?.parts|number}})
      <i class="fa fa-angle-down mr-1" *ngIf="(data?.subTypes | json) != '{}'"></i>
    </div>
    <div *ngIf="data?._more" class="fs-sm text-left " dir="ltr">
      <div *ngFor="let sub of data?.subTypes | keyvalue" class="d-flex border-top justify-content-between">
        <div>
          {{sub.key}}
        </div>
        <div>
          {{sub.value.count|number}} <span class="fs-sm" *ngIf="sub.value.parts">({{sub.value.parts|number}})</span>
        </div>
      </div>
    </div>

  </ng-template>
</ng-container>
<ng-container *ngIf="tab=='sms-action'">
  <div class="container table-responsive">
    <div class="d-flex pb-2 mb-2">
      <div>
        <button class="btn btn-secondary btn-sm fs-sm" (click)="loadSmsActionStats()">دریافت</button>
      </div>
    </div>

    <table class="w-100 table table-striped table-sm table-bordered">
      <thead>
        <tr>
          <td>پیامک</td>
          <td>تعداد</td>
          <td>کلیک</td>
          <td>عملیات</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of smsActionStats">
          <td>{{row.key}}</td>
          <td>
            {{row.smsCount | number}}
          </td>
          <td>
            {{row.clickCount | number}}
          </td>
          <td>
            <div class="pointer" (click)="row._showActions = !row._showActions">
              {{row.actionCount | number}}
              <i class="fa fa-angle-down mr-1"></i>
            </div>
            <div class="fs-sm" *ngIf="row._showActions">
              <div class="border-top text-left" dir="ltr" *ngFor="let action of row.actions">
                {{action.action}}: {{action.count|number}}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #seekerCell let-data="data">
    <div class="pointer" *ngIf="data" (click)="data._showUtm=!data._showUtm">
      {{data?.count|number}} بار
      <i class="fa fa-angle-down mr-1"></i>
    </div>
    <div *ngIf="data?.value" class="border-top">
      {{data?.value|number}} تومان
    </div>

    <div *ngIf="data?._showUtm" class="fs-sm text-left " dir="ltr">
      <div *ngFor="let utm of data?.utm" class="d-flex border-top justify-content-between">
        <div>
          <div *ngIf="utm.campaign">campaign: {{utm.campaign}}</div>
          <div *ngIf="utm.source">source: {{utm.source}}</div>
          <div *ngIf="utm.medium">medium: {{utm.medium}}</div>
        </div>
        <div>{{utm.count|number}}</div>
      </div>
    </div>

  </ng-template>
</ng-container>